export const environment = {
  production: false,
  apiURL:" https://eton-backend.azurewebsites.net/index.php/",
  rtfr:"FX0jt/ejjcukuEGWSULYxm7YT9b6lKHVzTJdEkBw67Y=",
  //this rtfr1 key to used to encrypt the server resources
  rtfr1: "atrgtfEeSPO0rMS1nMdCifAIzaSyDHeYh5YZ8uNZiQM7XHKZY6mCrsiAU0SOtS123456$#@$^@1ERF123456$#@$^@1ERF5tg456$#@$^@1xxx45dfdfdfdf",
  adminApiURL:" https://eton-backend.azurewebsites.net/index.php/",
};